import { render, staticRenderFns } from "./GonderilecekDilekcePicker.vue?vue&type=template&id=1b5da108"
import script from "./GonderilecekDilekcePicker.vue?vue&type=script&lang=ts"
export * from "./GonderilecekDilekcePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports